define('modules/accounts/status/products/mdirector/balance/transfer/model',['require','exports','module','env','base/model'],function (require, exports, module) {
    "use strict";

    var Config = require("env");
    var BaseModel = require("base/model");


    var model = BaseModel.extend({
        initialize: function(options) {
            this.initRequestEvents();

        },
        url: function() {
            return Config.backendUrl + "/accounts/balance-transaction";
        }
    });

    module.exports = model;
});
